// The prefix must start with OLK to avoid CTS(content transformation service) from appending x_ in front.
export const OUTLOOK_BEAUTIFIED_PREFIX = 'OLK_Beautified_';

export function isBeautifulLinkBasedOnId(anchorElement: HTMLAnchorElement): boolean {
    return anchorElement.id.indexOf(OUTLOOK_BEAUTIFIED_PREFIX) === 0;
}

export function addBeautifiedPrefixToId(anchorElement: HTMLAnchorElement) {
    anchorElement.id = OUTLOOK_BEAUTIFIED_PREFIX + anchorElement.id;
}
